import React, { useEffect, useState } from 'react';
import { Button, Col, Form, Input, InputNumber, Modal, Row, message } from 'antd';
import { fetchAPI } from '../../utils/use.api';
import Captcha from './Capcha';

export default function PopupUpdate(
  {
    fetchNewData,
    selectedRowKey,
    setSelectedRowKey,
  }: {
    fetchNewData: any,
    selectedRowKey: any,
    setSelectedRowKey: any
  }
) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();
  const [isChange, setIsChange] = useState(false);

  async function handleOk() {
    form.validateFields()
      .then((values) => {
        if (isChange) {
          fetchAPI({
            method: 'PUT',
            uri: '/posts/update/' + selectedRowKey._id,
            Headers: {
              'Content-Type': 'application/json',
              'AccessToken': localStorage.getItem('token')
            },
            body: JSON.stringify({
              ...values,
            }),
          })
            .then((res) => {
              if (res.acknowledged && res.modifiedCount === 1) {
                message.success('Cập nhật thành công');
                form.resetFields();
                setIsModalOpen(false);
                fetchNewData();
                setSelectedRowKey(null);
              } else {
                message.error('Cập nhật thất bại');
              }
            })
        } else {
          message.error('Vui lòng thay đổi thông tin');
        }
      })
      .catch((errorInfo) => {
        console.log(errorInfo);
      });
  };

  const handleCancel = () => {
    form.resetFields();
    setIsModalOpen(false);
  }

  useEffect(() => {
    form.setFieldsValue({
      name: selectedRowKey?.name,
      yearofbirth: selectedRowKey?.yearofbirth,
      hometown: selectedRowKey?.hometown,
      reach: selectedRowKey?.reach,
      engagement: selectedRowKey?.engagement,
      video_url: selectedRowKey?.video_url,
    });
  }, [selectedRowKey]);


  return (
    <>
      <Button type="primary" style={{ backgroundColor: 'orange' }} onClick={() => setIsModalOpen(true)}>
        Cập nhật
      </Button>
      <Modal
        title="Cập nhật"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={[
          <Row gutter={[10, 10]} justify={'end'}>
            <Col>
              <Button key="back" onClick={handleCancel}>
                Hủy
              </Button>
            </Col>
            <Col>
              <Captcha title='Cập nhật' callBack={handleOk} />
            </Col>
          </Row>
        ]}
      >
        <Form
          form={form}
          labelCol={{ span: 6 }}
          wrapperCol={{ span: 18 }}
        >
          <Form.Item
            name="name"
            label="Tên"
            rules={[
              {
                required: true,
                message: 'Vui lòng nhập tên',
              },
            ]}
          >
            <Input onChange={() => setIsChange(true)}/>
          </Form.Item>
          <Form.Item
            name="yearofbirth"
            label="Năm sinh"
            rules={[
              {
                required: true,
                message: 'Vui lòng năm sinh',
              },
            ]}
          >
            <InputNumber onChange={() => setIsChange(true)} />
          </Form.Item>
          <Form.Item
            name="hometown"
            label="Quê quán"
            rules={[
              {
                required: true,
                message: 'Vui lòng nhập quê quán',
              },
            ]}
          >
            <Input onChange={() => setIsChange(true)}/>
          </Form.Item>
          <Form.Item
            name="reach"
            label="Lượt Reach"
            rules={[
              {
                required: true,
                message: 'Vui lòng nhập lượt reach',
              },
            ]}
          >
            <InputNumber onChange={() => setIsChange(true)}/>
          </Form.Item>
          <Form.Item
            name="engagement"
            label="Engagement"
            rules={[
              {
                required: true,
                message: 'Vui lòng nhập engagement',
              },
            ]}
          >
            <InputNumber onChange={() => setIsChange(true)} />
          </Form.Item>
          <Form.Item
            name="video_url"
            label="YT Video ID"
            rules={[
              {
                required: true,
                message: 'Vui lòng nhập Youtube Video ID',
              },
            ]}
          >
            <Input onChange={() => setIsChange(true)} />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};
